import React from "react";

export const InheritedAccessHelpPanelContent: React.FC = (): JSX.Element => {
  return (
    <React.Fragment>
      <p>
        Admin access to a team cascades down to all subteams. Admins with
        inherited access from parent teams will appear in team permissions with
        the name of the team they inherited access from.{" "}
      </p>
      <p>
        Admins can only be removed at the direct access level, so parent team
        admins cannot be removed from sub teams.
      </p>
    </React.Fragment>
  );
};

export default InheritedAccessHelpPanelContent;
